import { render, staticRenderFns } from "./ExamPlaces.vue?vue&type=template&id=2f896b4c"
import script from "./ExamPlaces.vue?vue&type=script&lang=js"
export * from "./ExamPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports